import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ToxOffering from "@/pages/ToxOffering";

export const Route = createFileRoute("/zh-cn/services/regulatory-toxicology/nitrosamine-risk-assessment")({
  head: () => buildRouteHead("/zh-cn/services/regulatory-toxicology/nitrosamine-risk-assessment"),
  component: ToxOffering,
});

